import FeatureFlag from "@/domain/enums/FeatureFlag";
import LicenseValidity from "@/domain/enums/LicenseValidity";

type LicenseDetailsProps = {
    id: string;
    name: string;
    validity: LicenseValidity;
    isEnterprise: boolean;
    featureFlags: FeatureFlag[];
    initialAnalysis: {
        byMail: number;
        byDay: number;
    };
    monthlyLimit: {
        byToken: number;
        byAnalysedMails: number;
    };
    historyLimit: {
        byMail: number;
        byMonth: number;
    };
};

export default class LicenseDetails {
    id: string;

    name: string;

    validity: LicenseValidity;

    isEnterprise: boolean;

    featureFlags: FeatureFlag[];

    initialAnalysis: {
        byMail: number;
        byDay: number;
    };

    monthlyLimit: {
        byToken: number;
        byAnalysedMails: number;
    };

    historyLimit: {
        byMail: number;
        byMonth: number;
    };

    constructor({
        id,
        name,
        validity,
        isEnterprise,
        featureFlags,
        initialAnalysis,
        monthlyLimit,
        historyLimit,
    }: LicenseDetailsProps) {
        this.id = id;
        this.name = name;
        this.validity = validity;
        this.isEnterprise = isEnterprise;
        this.featureFlags = featureFlags;
        this.initialAnalysis = initialAnalysis;
        this.monthlyLimit = monthlyLimit;
        this.historyLimit = historyLimit;
    }
}
